import { DrugPricingRequest, DrugPricingResponse } from "../types";
import { request } from "./request";

export async function priceDrugAPI(drugPriceRequest: DrugPricingRequest): Promise<DrugPricingResponse> {
  return await request({
    url: "/drug/price/list",
    method: "POST",
    data: { ...drugPriceRequest },
  });
}
